<script>
export default {
	data() {
		return {
			model: null,
		}
	},
	props: ['value', 'label', 'disabled', 'required', 'rules', 'hint'],
	methods: {
		init() {
			if (this.value !== undefined && this.value !== null) {
				this.model = this.value
			}
		},
		update(value) {
			this.$emit('input', this.model)
			this.$emit('change', this.model)
		},
		empty() {
			this.model = null
			this.update()
		},
	},
	computed: {
		computedRules() {
			let res = []
			if (this.rules) {
				res = [...this.rules]
			}
			if (this.inputRequired) {
				res.push((v) => !!v || this.label + ' requis')
			}
			return res
		},
		inputRequired() {
			if (this.required && typeof this.required === 'function') {
				return this.required()
			}
			return this.required
		},
		inputDisabled() {
			if (this.disabled && typeof this.disabled === 'function') {
				return this.disabled()
			}
			return this.disabled
		},
	},
	watch: {
		value() {
			this.init()
		},
	},
	mounted() {
		this.init()
	},
}
</script>
<style lang="scss">
span {
	width: 100%;
}
.custom-error {
	.v-input__slot {
		display: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/inputs/baseInput.vue